import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { tryToGetItTabRapido } from 'app/entity/actions/entity.actions';
import { ResourceSharingOffer } from 'app/entity/models/rapido-offer';
import { isAuthorizedInKeycloak } from 'app/keycloak/reducers/keycloak.reducer';
import { State } from 'app/reducers';
import { RapidoOffersService } from 'app/services/rapido-offers.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-get-offers-button',
  templateUrl: './get-offers-button.component.html',
  styleUrls: ['./get-offers-button.component.scss'],
})
export class GetOffersButtonComponent {
  @Input() public resourceId: string;
  @Input() public recordId: string;
  @Input() public tabName: string;
  public isPatronAuthorized: boolean;
  public offer: ResourceSharingOffer;
  public offerError: boolean = false;
  public loading: boolean = false;
  private readonly subscriptions: Subscription = new Subscription();

  constructor(
    private readonly store: Store<State>,
    private readonly offersService: RapidoOffersService
  ) {}

  public ngOnInit() {
    this.subscriptions.add(
      this.store.select(isAuthorizedInKeycloak).subscribe((isAuthorized) => {
        this.isPatronAuthorized = isAuthorized;
        if (this.isPatronAuthorized) {
          this.getOffers();
        }
      })
    );
  }

  public getOffers() {
    this.offerError = false;
    this.offersService.getOffers(this.recordId).subscribe((offers) => {
      if (offers.length) {
        this.offer = offers[0];
        this.offerError = false;
      } else {
        this.offer = null;
        this.offerError = true;
      }
      this.loading = false;
    });
  }

  public onGetIt(event: Event) {
    event.stopPropagation();
    this.store.dispatch(tryToGetItTabRapido({cardInfo: {id: this.resourceId, tabName: this.tabName}}));
  }
}
